import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { StorageService } from '../services';
import { AppConstants } from '../models';

@Injectable({
  providedIn: 'root'
})
export class RequestInterceptorService implements HttpInterceptor {

  constructor(private storageService: StorageService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes(`token`)) return next.handle(request); // checks the login path

    if (request.url.includes(`User/FlushSession`)) {
      return throwError({ status: 401, error: { message: 'flusedSession' } });
    }

    const HEADERS = request.headers.append(`Authorization`, `Bearer ${this.storageService.GetToken()}`);
    const CLONED_REQUEST = request.clone({headers: HEADERS});
    
    return next.handle(CLONED_REQUEST);
  }
}
